import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import Sidebar from '../Sidebar';
import './styles.css';

class Bar extends React.PureComponent {
  static propTypes = {
    onClose: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    visible: PropTypes.bool,
    width: PropTypes.string,
    direction: PropTypes.string,
    hideCloseButton: PropTypes.bool,
  };

  static defaultProps = {
    width: 'very wide',
    direction: 'right',
  };

  render() {
    const { visible, width, direction, onClose, hideCloseButton } = this.props;
    return (
      <Sidebar
        animation="overlay"
        width={width}
        direction={direction}
        visible={visible}
        styleName="right-bar"
        onClose={onClose}
      >
        {!hideCloseButton && (
        <Button
          circular
          icon="close"
          data-cy="sidebar-close-btn"
          styleName="close-btn"
          onClick={onClose}
          aria-label="Close"
        />
        )}
        { this.props.children }
      </Sidebar>
    );
  }
}

export default Bar;
